const MAP = {
  received: ["info", "Received"],
  sap_only: ["success", "SAP IDoc only"],
  created: ["info", "Created"],
  test_hold: ["warning", "Test · held"],
  review_pending: ["warning", "To review"],
  review_confirmed: ["success", "Confirmed"],
  review_flagged: ["error", "Flagged"],
  released: ["info", "940 released"],
  shipped: ["success", "Shipped"],
  partially_shipped: ["warning", "Partially shipped"],
  short_shipped: ["error", "Short shipped"],
  cancelled: ["muted", "Cancelled"],
  in_transit: ["warning", "In transit"],
  delivered: ["success", "Received at xDock"],
  discrepancy: ["error", "Receipt discrepancy"],
  sent: ["info", "Sent"],
  partially_received: ["warning", "Partially received"],
  rejected: ["muted", "Rejected"],
  accepted: ["success", "997 accepted"],
  accepted_errors: ["warning", "997 accepted w/ errors"],
  partial: ["warning", "997 partial"],
  awaiting_997: ["muted", "Awaiting 997"],
  processed: ["success", "Processed"],
  exception: ["error", "Exception"],
  unmatched: ["error", "Unmatched"],
  error: ["error", "Error"],
  duplicate: ["warning", "Duplicate"],
  unsupported: ["muted", "Unsupported"],
  ready: ["warning", "Ready to send"],
  customer: ["info", "Customer"],
  replenishment: ["success", "Replenishment"],
};

const TONE = {
  info: "bg-sky-500/10 text-sky-300 border-sky-500/30",
  warning: "bg-amber-500/10 text-amber-300 border-amber-500/30",
  success: "bg-green-500/10 text-green-300 border-green-500/30",
  error: "bg-rose-500/10 text-rose-300 border-rose-500/30",
  muted: "bg-slate-500/10 text-slate-400 border-slate-600/40",
};

export const StatusBadge = ({ status, label, testId }) => {
  const [tone, text] = MAP[status] || ["muted", status];
  return (
    <span
      data-testid={testId || `status-${status}`}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-sm border px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider ${TONE[tone]}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label || text}
    </span>
  );
};
